import { S } from '@mobily/ts-belt';
import { Box, Color } from '@stitch-fix/mode-react';
import { ModuleFooter, type ModuleFooterProps } from '../ModuleFooter';
import { isEmpty } from '../JsonRteRenderer/JsonRteRenderer';
import { ModuleTitle, type ModuleTitleProps } from '../ModuleTitle';
export type ModuleWrapperProps = {
  alignment: 'left' | 'center';
  moduleTitle?: Pick<ModuleTitleProps, 'major' | 'title' | 'subtitle' | 'titleOrder' | 'titleFullWidth'>;
  moduleFooter?: Pick<ModuleFooterProps, 'link' | 'hideOnMobile' | 'buttonColor'>;
  children: React.ReactNode;
  textColor?: Color;
  majorTitleTextColor?: Color;
  minorTitleTextColor?: Color;
  /** Applies vertical padding to the module */
  includeYPadding?: boolean;
  /** Applies horizontal padding to the module title */
  gutter?: ModuleTitleProps['gutter'];
};
export const ModuleWrapper = ({
  alignment,
  moduleTitle,
  moduleFooter,
  children,
  includeYPadding = false,
  textColor,
  majorTitleTextColor,
  minorTitleTextColor,
  gutter = 'none'
}: ModuleWrapperProps) => {
  const hAlign = alignment === 'left' ? 'start' : 'center';
  const shouldRenderModuleTitle = moduleTitle && (!isEmpty(moduleTitle.major?.children) || !isEmpty(moduleTitle.title?.children) || !isEmpty(moduleTitle.subtitle?.children));
  const shouldRenderModuleFooter = moduleFooter && S.isNotEmpty(moduleFooter.link.href) && S.isNotEmpty(moduleFooter.link.title);
  return <Box py={includeYPadding ? 3 : 0}>
      {shouldRenderModuleTitle && <ModuleTitle hAlign={hAlign} major={moduleTitle.major} title={moduleTitle.title} subtitle={moduleTitle.subtitle} titleOrder={moduleTitle.titleOrder} textColor={textColor} majorTitleTextColor={majorTitleTextColor} minorTitleTextColor={minorTitleTextColor} titleFullWidth={moduleTitle.titleFullWidth} gutter={gutter} />}
      {children}
      {shouldRenderModuleFooter && <ModuleFooter hAlign={hAlign} link={moduleFooter.link} hideOnMobile={moduleFooter.hideOnMobile} buttonColor={moduleFooter.buttonColor} />}
    </Box>;
};